import Cookies from "js-cookie";

export class TokenHelper {
  private VITE_ACCESS_TOKEN_PART_ONE: string;
  private VITE_REFRESH_TOKEN_PART_ONE: string;
  private VITE_ACCESS_TOKEN_PART_TWO: string;
  private VITE_REFRESH_TOKEN_PART_TWO: string;

  constructor() {
    this.VITE_ACCESS_TOKEN_PART_ONE =
      import.meta.env.VITE_ACCESS_TOKEN_PART_ONE || "";
    this.VITE_REFRESH_TOKEN_PART_ONE =
      import.meta.env.VITE_REFRESH_TOKEN_PART_ONE || "";
    this.VITE_ACCESS_TOKEN_PART_TWO =
      import.meta.env.VITE_ACCESS_TOKEN_PART_TWO || "";
    this.VITE_REFRESH_TOKEN_PART_TWO =
      import.meta.env.VITE_REFRESH_TOKEN_PART_TWO || "";

    if (
      !this.VITE_ACCESS_TOKEN_PART_ONE ||
      !this.VITE_REFRESH_TOKEN_PART_ONE ||
      !this.VITE_ACCESS_TOKEN_PART_TWO ||
      !this.VITE_REFRESH_TOKEN_PART_TWO
    ) {
      throw new Error("Provide all keys.");
    }
  }

 setTokens(access: string, refresh?: string) {
  const accessArray = access?.split(".");
  const refreshArray = refresh?.split(".");

  if (!accessArray || accessArray.length !== 3) {
    console.error("Invalid access token structure");
    return;
  }

  if (refresh && (!refreshArray || refreshArray.length !== 3)) {
    console.error("Invalid refresh token structure");
    return;
  }

  // Proceed if valid
  localStorage.setItem(this.VITE_ACCESS_TOKEN_PART_ONE, accessArray[0]);
  Cookies.set(this.VITE_ACCESS_TOKEN_PART_TWO, `${accessArray[1]}.${accessArray[2]}`, {
    secure: true,
    sameSite: "Strict",
  });

  if (refreshArray) {
    localStorage.setItem(this.VITE_REFRESH_TOKEN_PART_ONE, refreshArray[0]);
    Cookies.set(this.VITE_REFRESH_TOKEN_PART_TWO, `${refreshArray[1]}.${refreshArray[2]}`, {
      secure: true,
      sameSite: "Strict",
    });
  }


}


 getTokens() {
  const accessPart1 = localStorage.getItem(this.VITE_ACCESS_TOKEN_PART_ONE);
  const accessPart2 = Cookies.get(this.VITE_ACCESS_TOKEN_PART_TWO);
  const refreshPart1 = localStorage.getItem(this.VITE_REFRESH_TOKEN_PART_ONE);
  const refreshPart2 = Cookies.get(this.VITE_REFRESH_TOKEN_PART_TWO);

  const access = accessPart1 && accessPart2 ? `${accessPart1}.${accessPart2}` : null;
  const refresh = refreshPart1 && refreshPart2 ? `${refreshPart1}.${refreshPart2}` : null;

  return { access, refresh };
}


  deleteTokens() {
    // Remove from localStorage
    localStorage.removeItem(this.VITE_ACCESS_TOKEN_PART_ONE);
    localStorage.removeItem(this.VITE_REFRESH_TOKEN_PART_ONE);

    // Remove from Cookies
    Cookies.remove(this.VITE_ACCESS_TOKEN_PART_TWO);
    Cookies.remove(this.VITE_REFRESH_TOKEN_PART_TWO);
  }
}
